import { Flex } from 'front-end/src/components'
import React from 'react'
import { CheckboxBig } from '../../../../components/common/form/checkbox/CheckboxBig'
import Spinner from '../../../../components/common/loader/Loader'
import { useLooopTheme } from '../../../../public-api/hooks/useLooopTheme'
import { IStudentSurveyQuestionTypeProps } from '../StudentSurveyQuestion'

import './ChooseQuestion.less'

const ChooseOneQuestion = ({
  question,
  setAnswer,
  answer
}: IStudentSurveyQuestionTypeProps) => {
  const { theme } = useLooopTheme()

  if (!question) {
    return <Spinner />
  }

  const options = question.content?.options ?? []

  return (
    <div className="ChooseOneQuestion ChooseQuestion">
      {options.map((option) => {
        const isSelected = option.id === answer
        return (
          <Flex
            key={option.id}
            className={'ChooseQuestion__option'}
            bg={isSelected ? theme.colors.buttonPrimary[100] : undefined}
            borderColor={
              isSelected ? theme.colors.buttonPrimary.default : undefined
            }
            _hover={{
              borderColor: `${theme.colors.buttonPrimary.default}`
            }}
            onClick={(ev) => {
              ev.preventDefault()
              setAnswer(option.id)
            }}
          >
            <CheckboxBig
              isRounded
              noIcon
              mr="16px"
              isChecked={option.id === answer}
            />
            <span className="ChooseQuestion__option__label">
              {option.label}
            </span>
          </Flex>
        )
      })}
    </div>
  )
}

export default ChooseOneQuestion
